import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectRoutingModule } from './project-routing.module';
import { LabelModule, PaginatorModule, SearchModule } from '@lead-hunter/ui';
import { TranslocoModule } from '@ngneat/transloco';
import { HeroIconModule, chevronRight, clipboardCheck, trash } from 'ng-heroicon';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { NgxPaginationModule } from 'ngx-pagination';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { AnalyzesComponent } from './containers/analyzes/analyzes.component';
import { BasesComponent } from './containers/bases/bases.component';
import { WarningExtractionModule } from '../../components/warning-extraction';
import { WarningProcessModule } from '../../components/warning-process';
import { WarningExpiredModule } from '../../components/warning-expired';
import { WarningRemoveModule } from '../../components/warning-remove';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [AnalyzesComponent, BasesComponent],
  imports: [
    CommonModule,
    ProjectRoutingModule,
    HeroIconModule.withIcons({
      clipboardCheck,
      trash,
      chevronRight
    }),
    WarningExtractionModule,
    WarningProcessModule,
    WarningExpiredModule,
    WarningRemoveModule,
    LabelModule,
    SearchModule,
    TranslocoModule,
    MatButtonModule,
    MatDividerModule,
    NgxPaginationModule,
    MatIconModule,
    PaginatorModule,
    BreadcrumbModule,
    MatTooltipModule,
  ],
})
export class ProjectModule {}
